module.exports = __webpack_public_path__ + "img/logo_sid.66db1753.png";